<template>
	<BasicTile class="profile-edit-dashboard background-tile-big">


		<UserProfileHeader>
			<template v-slot:append-right>
				<button @click="$router.push('/profile')"
					class="button--primary rounded-pill button__profile-settings py-4 px-8 d-flex">
					View Profile
				</button>
			</template>
		</UserProfileHeader>



		<v-divider/>



		<v-form @submit="submitForm" ref="form" class="user-information">

			<CustomInput label="Name" placeholder="john doe" v-model="user.name" :error-messages="[]" type="text"
				:disabled="true" />

			<CustomInput label="Email Address" placeholder="johndoe@example.com" v-model="user.email"
				:error-messages="[]" type="email" :disabled="true" />

			<div>
				<span class="mb-1 text-14 weight-500">Phone Number</span>
				<vue-tel-input v-model="phoneNumber" mode="international" :key="phoneISOCode" class="auth-input mt-1"
					:onlyCountries="countries.map(({ region_code }) => region_code)" :defaultCountry="phoneISOCode"
					:autoFormat="false" :dropdownOptions="{
						showFlags: true,
						showDialCodeInList: true,
						showDialCodeInSelection: true
					}" @country-changed="handleCountryChange" />
			</div>

		</v-form>


		<div class="withdrawal-information">
			<div class="title">Withdrawal Information</div>


			<v-row>
				<v-col cols="12" sm="6" md="4">
					<CustomInput label="PayPal Email" placeholder="johndoe21@example.com" v-model="paypalEmail"
						:error-messages="[]" type="email" />
				</v-col>
			</v-row>
		</div>


		<div class="d-flex justify-center flex-wrap ga-5">
			<button :loading="savingProfile" class="rounded-pill button--secondary py-4 px-8 px-sm-16 d-flex button__profile-settings"
				@click="cancelChanges"
				:disabled="paypalEmail === paypalEmailComputed && phoneNumber === phoneNumberComputed">
				Cancel
			</button>
			<button :loading="savingProfile" class="rounded-pill button--primary py-4 px-8 d-flex button__profile-settings" @click="saveChanges">
				Save Changes
			</button>
			<button class="rounded-pill button--secondary py-4 px-8 d-flex button__profile-settings" @click="openDialog = true">
				Delete Account
			</button>
		</div>

	</BasicTile>
	<DeleteAccountDialog />
</template>



<script setup>

import 'vue-tel-input/vue-tel-input.css';
import { VueTelInput } from 'vue-tel-input';
import { ref, computed, watch, provide } from 'vue';

import { useUserStore } from "@/store/UserStore";
import { useSnackbar } from '@/composables/useSnackbar';
import { PayoutStore } from "@/store/PayoutStore";

import BasicTile from "@/components/Tiles/Basic-Tile.vue";
import CustomInput from "@/components/Common/CustomInput.vue";
import UserProfileHeader from "@/components/Profile/User-Profile-Header.vue";
import DeleteAccountDialog from "@/components/Profile/Delete-Account-Dialog.vue";


const { showSnackbar } = useSnackbar();
const userStore = useUserStore();
const payoutStore = PayoutStore();

const phoneNumber = ref(userStore.user.phone_number);
const paypalEmail = ref(userStore.user.paypal_email);
const phoneISOCode = ref(userStore.user.phone_iso_code);
const phoneCountryCode = ref(userStore.user.phone_country_code);


const user = computed(() => userStore.user);
const countries = computed(() => payoutStore.PayoutOptionCountries);

const phoneNumberComputed = computed(() => userStore.user.phone_number);
const paypalEmailComputed = computed(() => userStore.user.paypal_email);
const phoneISOCodeComputed = computed(() => userStore.user.phone_iso_code);
const phoneCountryCodeComputed = computed(() => userStore.user.phone_country_code);


const savingProfile = ref(false);

let openDialog = ref(false);
provide('openDialog', openDialog);



watch(phoneNumberComputed, (newVal, oldVal) => {
	if (newVal !== oldVal) {
		phoneNumber.value = newVal;
	}
});

watch(phoneISOCodeComputed, (newVal, oldVal) => {
	if (newVal !== oldVal) {
		phoneISOCode.value = newVal;
	}
});

watch(phoneCountryCodeComputed, (newVal, oldVal) => {
	if (newVal !== oldVal) {
		phoneCountryCode.value = newVal;
	}
});

watch(paypalEmailComputed, (newVal, oldVal) => {
	if (newVal !== oldVal) {
		paypalEmail.value = newVal;
	}
});


const handleCountryChange = (country) => {
	phoneISOCode.value = country.iso2;
	phoneCountryCode.value = country.dialCode;
};

const saveChanges = async () => {
	try {
		savingProfile.value = true;
		await userStore.updateUserProfile(phoneNumber.value, phoneISOCode.value, phoneCountryCode.value, paypalEmail.value);
		showSnackbar({
			message: 'Profile updated successfully',
			color: 'success'
		});
	} catch (error) {
		// handle error
		console.error(error);
	} finally {
		savingProfile.value = false;
	}
};

const cancelChanges = () => {
	paypalEmail.value = userStore.user.paypal_email;
	phoneNumber.value = userStore.user.phone_number;
	phoneISOCode.value = userStore.user.phone_iso_code;
	phoneCountryCode.value = userStore.user.phone_country_code;
};

</script>



<style scoped lang="scss">
@use "@/assets/scss/input-mixins" as input-mixins;
@use "@/assets/scss/button-mixins" as button-mixins;
</style>